import { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { portalLinks } from './portal-links'
import { FINAL_CTA_RISK_NOTICE, RISK_LINKS } from './risk-copy'
import './web-test-final.css'
import { trackClientLogin, trackOpenAccount, trackRiskDisclosure } from '../analytics/track'

export function WebTestFinalCta() {
  const rootRef = useRef<HTMLElement>(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const el = rootRef.current
    if (!el) return
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setVisible(true)
          io.disconnect()
        }
      },
      { threshold: 0.15 },
    )
    io.observe(el)
    return () => io.disconnect()
  }, [])

  const [before, after] = FINAL_CTA_RISK_NOTICE.split('Risk Disclosure')

  return (
    <section
      ref={rootRef}
      id="ready-to-begin"
      className={`wfc-section wfc-section--compact${visible ? ' is-visible' : ''}`}
      aria-labelledby="wfc-title"
    >
      <div className="wfc-inner">
        <header className="wfc-intro pp-enter" style={{ ['--pp-i' as string]: 0 }}>
          <h2 id="wfc-title" className="wfc-title">
            Start Structured Prediction Trading
          </h2>
          <p className="wfc-subtitle">
            Open your Live Trading Account and manage your trading journey through the secure Client
            Portal.
          </p>
        </header>

        <div className="wfc-cta pp-enter" style={{ ['--pp-i' as string]: 1 }}>
          <a
            className="wt-btn wt-btn--primary wt-btn--hero"
            href={portalLinks.register}
            onClick={() => trackOpenAccount('footer')}
          >
            Open Live Account
          </a>
          <a
            className="wt-btn wt-btn--secondary wt-btn--hero"
            href={portalLinks.login}
            onClick={() => trackClientLogin('footer')}
          >
            Client Portal Login
          </a>
        </div>

        <p className="wfc-note pp-enter" style={{ ['--pp-i' as string]: 2 }}>
          {before}
          <Link to={RISK_LINKS.disclosure} onClick={() => trackRiskDisclosure('footer')}>
            Risk Disclosure
          </Link>
          {after}
        </p>
      </div>
    </section>
  )
}
